import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField, FormControlLabel, Checkbox } from "@mui/material";
import SimuladorNumericInput from "../../SimuladorIncentivos/SimuladorNumericInput";
import { GetText } from "../../../Helpers/GetKey";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { getUltimoDiaMes, handleChangeMoneda } from "./helperVentas/FuncionesCootizacion";
import { fechaMMDDaInput } from "../../../Helpers/FormatFecha";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const RegistrarCotizacionesScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const folio = state.folio
  const puedeEliminar = state.puedeEliminar
  const [moneda, setMoneda] = useState("MXN");
  const [cotizacion_existente, setCotizacion_existente] = useState(false);

  const [infoCotizacion, setInfoCotizacion] = useState({
    idCliente: "",
    asesorventa: "",
    razon_social: "",
    vigencia: getUltimoDiaMes(),
    esquemapago: "",
    moneda: "",
    terminos: "",
    detalle: [],
  });

  const [detalle, setDetalle] = useState({
    lineaventa: "Seleccionar Linea de Venta",
    modelo: "",
    descripcion: "",
    esquemapago: "",
    descuentoadicional: 0,
    preciolista: 0,
    preciopromocion: 0,
    precioventa: 0,
    cantidad: 1
  });

  const [modelosAgregados, setModelosAgregados] = useState([]);

  const [rol, setRol] = useState("");
  const [data_asesores, setAsesores] = useState([]);
  const [data_clientes, setClientes] = useState([]);
  const [data_lineaventa, setData_lineaventa] = useState([]);
  const [data_modelos, setData_modelos] = useState([]);
  const [data_esquemas, setData_esquemas] = useState([]);
  const [modelosFiltrados, setModelosFiltrados] = useState([]);
  const [mostrarPrecioLista, setMostrarPrecioLista] = useState(true);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    if (!infoCotizacion.esquemapago || data_modelos.length === 0) {
      setData_lineaventa([]);
      return;
    }
    const idEsquema = infoCotizacion.esquemapago.split(" - ")[0]?.trim();
    const modelosFiltrados = idEsquema === '0'
      ? data_modelos
      : data_modelos.filter(
        (m) => String(m.idpromocion).trim() === idEsquema
      );
    const lineasUnicas = Array.from(
      new Map(
        modelosFiltrados.map((m) => [
          m.idlinea,
          { id: m.idlinea, descripcion: m.linea_venta },
        ])
      ).values()
    );

    setData_lineaventa(lineasUnicas);
  }, [infoCotizacion.esquemapago, data_modelos]);

  useEffect(() => {
    if (
      !infoCotizacion.esquemapago ||
      !detalle.lineaventa ||
      data_modelos.length === 0
    ) {
      setModelosFiltrados([]);
      return;
    }

    const idEsquema = infoCotizacion.esquemapago.split(" - ")[0]?.trim();
    const idLinea = detalle.lineaventa.split(" - ")[0]?.trim();

    let filtrados = [];

    if (idEsquema === "0") {
      filtrados = data_modelos.filter(
        (m) => String(m.idlinea).trim() === String(idLinea)
      );
    } else {
      filtrados = data_modelos.filter(
        (m) =>
          String(m.idpromocion).trim() === String(idEsquema) &&
          String(m.idlinea).trim() === String(idLinea)
      );
    }
    const unicos = Array.from(
      new Map(filtrados.map((m) => [m.idmodelo, m])).values()
    );

    setModelosFiltrados(unicos);
  }, [infoCotizacion.esquemapago, detalle.lineaventa, data_modelos]);

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CotizacionVentas/ConsultarFolio?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setClientes(result.clientes);
        setAsesores(result.asesorventas);
        setRol(result.rol.rol);
        setData_esquemas(result.esquemas);
        setCotizacion_existente(
          result.cotizacion.folio != "XXXXX" ? true : false
        );
        setInfoCotizacion({
          ...infoCotizacion,
          idCliente: result.cotizacion.cliente,
          asesorventa: result.cotizacion.asesorventa,
          razon_social: result.cotizacion.razon_social,
          vigencia:
            result.cotizacion.vigencia === null
              ? getUltimoDiaMes()
              : result.cotizacion.vigencia,
          esquemapago: result.cotizacion.promocion,
          moneda: result.cotizacion.moneda,
          terminos: result.cotizacion.terminos,
          detalle: [],
        });
        setMostrarPrecioLista(!!result.cotizacion.imprimir_precio_lista);
        setModelosAgregados(
          result.detalle.map((item) => {
            const [idModeloStr, nombreModelo] = item.modelo.split(" - ");
            const idModelo = parseInt(idModeloStr, 10);

            return {
              idTemporal: Date.now() + Math.random(),
              idlinea: item.idlinea,
              idmodelo: idModelo,
              nombreModelo: `${idModelo} - ${nombreModelo}`,
              descripcion: item.descripcion,
              lineaventa: item.linea,
              descuentoadicional: item.descuento_adicional,
              descuentopromocion: item.descuento_promocion,
              preciolista: item.precio_lista,
              preciopromocion: item.precio_promocion,
              precioventa: item.precio_venta,
              esquemapago: "",
              cantidad: item.cantidad
            };
          })
        );

        setData_modelos(result.modelos)
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("COTIZACION DE VENTA", JSON.stringify(error), "error");
      });
  }, []);

  const handleAgregarModelo = () => {
    if (!detalle.modelo || detalle.lineaventa === "Seleccionar Linea de Venta") {
      Swal.fire("Atención", "Debes seleccionar una línea y un modelo", "warning");
      return;
    }

    const [idModeloStr] = detalle.modelo.split(" - ");
    const idModelo = parseInt(idModeloStr, 10);

    const [idLineaStr] = detalle.lineaventa.split(" - ");
    const idLinea = parseInt(idLineaStr, 10);

    // Si mostrarPrecioLista es false, solo el precio lista y descuento promoción se van en 0
    // const precioLista = mostrarPrecioLista ? detalle.preciolista : 0;

    // 🔹 SIEMPRE usar precios reales para cálculo
    const precioListaReal = detalle.preciolista;
    const precioPromocionReal = detalle.preciopromocion;

    const precioBase =
      precioPromocionReal > 0 ? precioPromocionReal : precioListaReal;


    const descuentoPromocion =
      precioPromocionReal === 0
        ? 0
        : mostrarPrecioLista
          ? precioListaReal - precioPromocionReal
          : 0;

    //Calcular correctamente SIEMPRE
    const precioVenta =
      precioPromocionReal === 0
        ? precioListaReal - detalle.descuentoadicional
        : precioPromocionReal - detalle.descuentoadicional;

    // 🔹 SOLO ocultar para guardar si es necesario
    const precioLista = mostrarPrecioLista ? precioListaReal : 0;

    const esLineCantidad =
      detalle.lineaventa === "8 - REFACCIONES" ||
      detalle.lineaventa === "9 - FERRETERIA";
    const cantidad = esLineCantidad ? Math.max(1, parseInt(detalle.cantidad, 10) || 1) : 1;

    // precioventa = (precio unitario * cantidad) - descuento total
    const precioBaseUnitario = precioPromocionReal === 0 ? precioListaReal : precioPromocionReal;
    const precioVentaTotal = (precioBaseUnitario * cantidad) - detalle.descuentoadicional;

    if (detalle.descuentoadicional > (precioBaseUnitario * cantidad)) {
      Swal.fire({
        icon: "warning",
        title: "Descuento inválido",
        text: "El descuento adicional no puede ser mayor que el precio del artículo.",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    const nuevoModelo = {
      ...detalle,
      idmodelo: idModelo,
      nombreModelo: detalle.modelo,
      preciolista: precioLista,
      preciopromocion: precioPromocionReal,
      descuentopromocion: descuentoPromocion,
      descuentoadicional: detalle.descuentoadicional,
      precioventa: precioVentaTotal,
      cantidad: cantidad,
      idTemporal: Date.now(),
      idlinea: idLinea,
    };

    setModelosAgregados((prev) => [...prev, nuevoModelo]);

    setDetalle({
      lineaventa: "",
      modelo: "",
      descripcion: "",
      esquemapago: "",
      descuentoadicional: 0,
      preciolista: 0,
      preciopromocion: 0,
      precioventa: 0,
      idlinea: "",
      cantidad: 1,
    });
  };

  const handleEliminarModelo = (idTemporal) => {
    const modelo = modelosAgregados.find((m) => m.idTemporal === idTemporal);
    const textoModelo = modelo.modelo || modelo.nombreModelo || "";
    const nombreModelo = textoModelo.includes(" - ")
      ? textoModelo.split(" - ")[1]
      : textoModelo;

    Swal.fire({
      title: '¿Estás seguro?',
      text: `Se eliminará el modelo "${nombreModelo}" de la cotización.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        setModelosAgregados((prev) =>
          prev.filter((m) => m.idTemporal !== idTemporal)
        );
        Swal.fire('Eliminado', 'El modelo ha sido eliminado.', 'success');
      }
    });
  };

  useEffect(() => {
    const idEsquema = infoCotizacion.esquemapago?.split(" - ")[0]?.trim() || "0";
    const esEsquemaCero = idEsquema === "0";

    // 🔹 Actualiza el detalle actual
    if (!mostrarPrecioLista) {
      setDetalle((prev) => ({
        ...prev,
        precioventa:
          esEsquemaCero
            ? prev.preciolista - prev.descuentoadicional
            : prev.preciopromocion - prev.descuentoadicional,
      }));
    } else if (detalle.modelo) {
      const modeloSeleccionado = modelosFiltrados.find(
        (m) => `${m.idmodelo} - ${m.modelo}` === detalle.modelo
      );

      if (modeloSeleccionado) {
        setDetalle((prev) => ({
          ...prev,
          preciolista: modeloSeleccionado.precio_lista,
          preciopromocion: esEsquemaCero ? 0 : modeloSeleccionado.precio_promocion,
          precioventa:
            (esEsquemaCero
              ? modeloSeleccionado.precio_lista
              : modeloSeleccionado.precio_promocion) - prev.descuentoadicional,
        }));
      }
    }

    setModelosAgregados((prev) =>
      prev.map((m) => {
        // Si mostrarPrecioLista está apagado, ocultamos el precio lista y ajustamos venta
        if (!mostrarPrecioLista) {
          return {
            ...m,
            preciolista: 0,
            precioventa:
              esEsquemaCero
                ? m.preciolista - m.descuentoadicional
                : m.preciopromocion - m.descuentoadicional,
          };
        }

        // Si se vuelve a activar, restauramos el precio original del modelo (usando data_modelos)
        const modeloBase = data_modelos.find(
          (md) => md.idmodelo === m.idmodelo
        );

        if (modeloBase) {
          const precioLista = modeloBase.precio_lista;
          const precioPromocion = esEsquemaCero ? 0 : modeloBase.precio_promocion;
          const precioVenta =
            (esEsquemaCero ? precioLista : precioPromocion) - m.descuentoadicional;

          return {
            ...m,
            preciolista: precioLista,
            preciopromocion: precioPromocion,
            precioventa: precioVenta,
          };
        }

        return m;
      })
    );
  }, [mostrarPrecioLista]);

  // console.log(modelosAgregados)

  const guardarCotizacion = () => {

    if (infoCotizacion.idCliente === "" || infoCotizacion.idCliente === null || infoCotizacion.idCliente === undefined) {
      Swal.fire({
        title: "COTIZACION",
        text: "Debe seleccionar un cliente",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    if (infoCotizacion.razon_social === "" || infoCotizacion.razon_social === null || infoCotizacion.razon_social === undefined) {
      Swal.fire({
        title: "COTIZACION",
        text: "Debe seleccionar un cliente",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    if (infoCotizacion.vigencia === "" || infoCotizacion.vigencia === null || infoCotizacion.vigencia === undefined) {
      Swal.fire({
        title: "COTIZACION",
        text: "Debe seleccionar la vigencia de la cotizacion",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    if (infoCotizacion.moneda === "" || infoCotizacion.moneda === null || infoCotizacion.moneda === undefined || infoCotizacion.precioLista <= 0) {
      Swal.fire({
        title: "COTIZACION",
        text: "Debe seleccionar la moneda de la cotizacion",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    if (infoCotizacion.esquemapago === "" || infoCotizacion.esquemapago === null || infoCotizacion.esquemapago === undefined || infoCotizacion.precioLista <= 0) {
      Swal.fire({
        title: "COTIZACION",
        text: "Debe seleccionar el esquema de pago de la cotizacion",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    if (!Array.isArray(modelosAgregados) || modelosAgregados.length === 0) {
      Swal.fire({
        title: "COTIZACION",
        text: "Debe ingresar al menos un modelo para cotizar",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0); // Evita errores por horas

    const [anio, mes, dia] = infoCotizacion.vigencia.split("-").map(Number);
    const vigenciaSeleccionada = new Date(anio, mes - 1, dia, 0, 0, 0, 0);

    // Validar que la fecha no sea menor a hoy si la cotización NO es existente
    if (!cotizacion_existente && vigenciaSeleccionada <= hoy) {
      Swal.fire({
        title: "COTIZACIÓN",
        text: "La vigencia no puede ser menor a la fecha actual",
        icon: "warning",
        customClass: { container: "mi-superpoop" }
      });
      return;
    }

    const idAsesorSolo = parseInt(
      infoCotizacion.asesorventa?.split(" - ")[0] || infoCotizacion.idAsesor || 0,
      10
    );

    const idEsquemaSolo = parseInt(
      infoCotizacion.esquemapago?.split(" - ")[0] || infoCotizacion.idEsquemaPago || 0,
      10
    );
    const mdl = {
      folio: folio,
      idcliente: infoCotizacion.idCliente,
      razon_social: infoCotizacion.razon_social,
      idasesor: idAsesorSolo,
      vigencia: infoCotizacion.vigencia,
      idEsquema: idEsquemaSolo,
      moneda: infoCotizacion.moneda,
      mostrar_precio_lista: mostrarPrecioLista ? 1 : 0,
      usuario: 0,
      terminos: infoCotizacion.terminos,
      // detalle: JSON.stringify(modelosAgregados)
      detalle: JSON.stringify(
        modelosAgregados.map((m) => ({
          lineaventa: m.lineaventa,
          modelo: m.nombreModelo,
          descripcion: m.descripcion,
          esquemapago: m.esquemapago || "",
          descuento_adicional: m.descuentoadicional,
          precio_lista: m.preciolista,
          precio_promocion: m.preciopromocion,
          precio_venta: m.precioventa,
          idmodelo: m.idmodelo,
          nombreModelo: m.nombreModelo,
          descuento_promocion: m.descuentopromocion,
          cantidad: m.cantidad,
          idTemporal: m.idTemporal,
          idlinea: m.idlinea,
        }))
      )
    }
    request
      .post(`CotizacionVentas/AgregarCotizacion`, mdl)
      .then(async (result) => {
        // onClose();
        await Swal.fire({
          title: "MODELOS",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        history.push("/Ventas/Cotizaciones");
      })
      .catch((error) => {
        console.log(error)
        Swal.fire("MODELOS", JSON.stringify(error), "error");
      });
  };

  // console.log(detalle)

  return (
    <PlantillaScreen
      titulo={"REGISTRO DE COTIZACIONES"}
      className={"registro_cotizaciones_main"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="registro_cotizaciones-actions">
        <div
          className="registro_cotizaciones-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
      </div>
      <div className="registro_cotizaciones_main_container">

        <div className="registro_cotizaciones_REncabezado">
          <h3>Datos de la Cotización </h3>
          <Autocomplete
            size="small"
            id="dash-razonsocial"
            freeSolo
            options={data_clientes}
            disabled={cotizacion_existente}
            sx={{
              mt: 1,
            }}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.label || ""
            }
            value={
              // Si el idCliente existe, usa ese cliente
              data_clientes.find((c) => c.id === infoCotizacion.idCliente) ||
              // Si no, muestra el texto libre que se escribió
              (infoCotizacion.razon_social ? infoCotizacion.razon_social : null)
            }
            onChange={(_, newValue) => {
              if (typeof newValue === "string") {
                // Texto libre no está en la lista
                setInfoCotizacion({
                  ...infoCotizacion,
                  razon_social: newValue,
                  idCliente: 0,
                });
              } else if (newValue && newValue.id) {
                // Cliente seleccionado de la lista
                setInfoCotizacion({
                  ...infoCotizacion,
                  razon_social: newValue.label,
                  idCliente: newValue.id,
                });
              } else {
                // Campo limpio
                setInfoCotizacion({
                  ...infoCotizacion,
                  razon_social: "",
                  idCliente: 0,
                });
              }
            }}
            onInputChange={(_, inputValue, reason) => {
              if (reason === "input") {
                setInfoCotizacion({
                  ...infoCotizacion,
                  razon_social: inputValue,
                  idCliente: 0,
                });
              }
            }}
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.id} - {option.label}
              </li>
            )}
            renderInput={(params) => <TextField {...params} label="Cliente" />}
          />

          {rol === "No_Asesor" && (
            <Autocomplete
              fullWidth
              size="small"
              id="asesorventa"
              freeSolo
              disabled={cotizacion_existente}
              value={infoCotizacion.asesorventa || ""}
              onChange={(_, newValue) => {
                if (typeof newValue === "string") {
                  // Si el usuario escribe a mano
                  setInfoCotizacion({
                    ...infoCotizacion,
                    asesorventa: newValue,
                    idAsesor: 0,
                  });
                } else if (newValue) {
                  const [idStr] = newValue.split(" - ");
                  setInfoCotizacion({
                    ...infoCotizacion,
                    asesorventa: newValue,
                    idAsesor: parseInt(idStr, 10),
                  });
                } else {
                  // Si limpia el campo
                  setInfoCotizacion({
                    ...infoCotizacion,
                    asesorventa: "",
                    idAsesor: 0,
                  });
                }
              }}
              options={data_asesores.map(
                (option) => `${option.id} - ${option.label}`
              )}
              renderInput={(params) => (
                <TextField {...params} label="Asesor de Venta" />
              )}
              sx={{ mt: 1.5 }}
            />

          )}

          <Autocomplete
            fullWidth
            size="small"
            id="esquema_pago"
            freeSolo
            // disabled={cotizacion_existente || modelosAgregados.length > 0}
            value={infoCotizacion.esquemapago || ""}
            onChange={(_, newValue) => {
              let nuevoEsquema = "";
              let idEsquema = 0;
              let vigenciaSeleccionada = null;
              // Parseo explicito: Safari no interpreta MM/dd/yyyy con hora.
              const formatFecha = (fecha) => fechaMMDDaInput(fecha);
              if (newValue) {
                const [idStr] = newValue.split(" - ");
                idEsquema = parseInt(idStr, 10);
                nuevoEsquema = newValue;

                const esquema = data_esquemas.find(
                  (item) => String(item.id) === String(idEsquema)
                );
                if (esquema?.vigencia) {
                  vigenciaSeleccionada = esquema.vigencia;
                }
              }

              const nuevaVigencia = formatFecha(vigenciaSeleccionada) || getUltimoDiaMes();

              setInfoCotizacion({
                ...infoCotizacion,
                esquemapago: nuevoEsquema,
                idEsquemaPago: idEsquema,
                vigencia: nuevaVigencia,
              });

              setModelosAgregados([]); //Limpiar los modelos seleccionados cuando cambian el esquema

              // Limpiar dependencias
              setDetalle((prev) => ({
                ...prev,
                lineaventa: "Seleccionar Linea de Venta",
                modelo: "",
              }));
              setData_lineaventa([]);
              setModelosFiltrados([]);
            }}
            options={data_esquemas.map(
              (option) => `${option.id} - ${option.label}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Esquema de pago" />
            )}
            sx={{ mt: 1.5 }}
          />


          <TextField
            fullWidth
            size="small"
            variant="outlined"
            sx={{
              mt: 1.5,
            }}
            // disabled={
            //   cotizacion_existente ||
            //   (Number(String(infoCotizacion.esquemapago).split(" - ")[0]) !== 0) ||
            //   modelosAgregados.length > 0
            // }
            type="date"
            label="Vigencia"
            InputLabelProps={{ shrink: true }}
            onChange={({ target }) => {
              setInfoCotizacion((prev) => ({
                ...prev,
                vigencia: target.value,
              }));
            }}
            value={infoCotizacion.vigencia}
          />

          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "12px" }}>
            <FormControl fullWidth size="small">
              <InputLabel id="moneda-label">Moneda</InputLabel>
              <Select
                labelId="moneda-label"
                id="select-moneda"
                value={moneda}
                label="Moneda"
                disabled={cotizacion_existente || modelosAgregados.length > 0}
                onChange={(e) =>
                  handleChangeMoneda(e.target.value, setMoneda, setInfoCotizacion)
                }
                sx={{
                  height: "34px",
                  display: "flex",
                  alignItems: "center",
                  "& .MuiSelect-select": {
                    paddingY: "8px",
                  },
                }}
              >
                <MenuItem key={"MXN"} value={"MXN"}>
                  Pesos mexicanos
                </MenuItem>
                <MenuItem key={"USD"} value={"USD"}>
                  Dólares
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small">
              <FormControlLabel
                control={
                  <Checkbox
                    // disabled={cotizacion_existente || modelosAgregados.length > 0}
                    checked={mostrarPrecioLista}
                    onChange={(e) => setMostrarPrecioLista(e.target.checked)}
                  />
                }
                label="Mostrar Precio de Lista"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "10px", // Ajusta el tamaño de la letra
                  },
                }}
              />
            </FormControl>
          </div>
          {/* <div className="registro-cotizaciones-separador">Modelos</div> */}



          <TextField
            fullWidth
            multiline
            rows={3}
            label="Términos y condiciones"
            size="small"
            variant="outlined"
            sx={{ mt: 2 }}
            // disabled={cotizacion_existente}
            value={infoCotizacion.terminos || ""}
            onChange={(e) => setInfoCotizacion({ ...infoCotizacion, terminos: e.target.value })}
          />

          {modelosAgregados.length > 0 && (
            <div
              className="button registro_cotizaciones_guardar_cotizacion"
              onClick={guardarCotizacion}
            >
              Guardar Cotización
            </div>
          )}
        </div>
        <div className="registro_cotizaciones_contenido">
          {/* Columna izquierda: Visualizador */}
          <div className="registro_cotizaciones_visualizador">
            <h3>Visualizador de modelo</h3>
            <div className="registro-cotizaciones-contenido-box">
              <Autocomplete
                fullWidth
                size="small"
                id="linea_venta"
                freeSolo
                value={detalle.lineaventa}
                onChange={({ target }) =>
                  setDetalle({
                    ...detalle,
                    lineaventa: target.outerText,
                    modelo: "",
                    descripcion: "",
                    preciolista: 0,
                    preciopromocion: 0,
                    precioventa: 0,
                    descuentoadicional: 0,
                    cantidad: 1,
                  })
                }
                options={data_lineaventa.map(
                  (option) => `${option.id} - ${option.descripcion}`
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Linea de Venta" />
                )}
              // sx={{ mt: 1.5 }}
              />
              <Autocomplete
                fullWidth
                size="small"
                id="modelo"
                freeSolo
                value={detalle.modelo}
                onChange={(_, newValue) => {
                  const idEsquema =
                    infoCotizacion.esquemapago?.split(" - ")[0]?.trim() || "";
                  const idModeloSeleccionado = newValue?.split(" - ")[0]?.trim();

                  // Buscar modelo en la lista filtrada
                  const modeloSeleccionado = modelosFiltrados.find(
                    (m) => String(m.idmodelo) === String(idModeloSeleccionado)
                  );

                  if (modeloSeleccionado) {
                    // Si el esquema es "0", el precio promoción se anula
                    const precioPromocion =
                      idEsquema === "0" ? 0 : modeloSeleccionado.precio_promocion;

                    setDetalle({
                      ...detalle,
                      modelo: `${modeloSeleccionado.idmodelo} - ${modeloSeleccionado.modelo}`,
                      descripcion: modeloSeleccionado.desc_modelo,
                      preciolista: modeloSeleccionado.precio_lista,
                      preciopromocion: precioPromocion,
                      precioventa:
                        (idEsquema === "0"
                          ? modeloSeleccionado.precio_lista
                          : modeloSeleccionado.precio_promocion) -
                        detalle.descuentoadicional,
                    });
                  } else {
                    // Si se escribe texto libre o se borra la selección
                    setDetalle({
                      ...detalle,
                      modelo: newValue || "",
                      descripcion: "",
                      preciolista: 0,
                      preciopromocion: 0,
                      precioventa: 0,
                    });
                  }
                }}
                options={modelosFiltrados.map(
                  (option) => `${option.idmodelo} - ${option.modelo}`
                )}
                renderInput={(params) => <TextField {...params} label="Modelo" />}
                sx={{ mt: 1.5 }}
              />

              {(detalle.lineaventa === "8 - REFACCIONES" || detalle.lineaventa === "9 - FERRETERIA") && (
                <SimuladorNumericInput
                  name="cantidad"
                  label="Cantidad"
                  value={detalle.cantidad}
                  disabled={false}
                  onChange={({ target }) => {
                    setDetalle({ ...detalle, cantidad: target.value });
                  }}

                  icono="numero"
                  className="registro_cotizaciones_descuento_adicional"
                />
              )}

              <SimuladorNumericInput
                name="sueldo"
                label="Descuento Adicional"
                value={detalle.descuentoadicional}
                disabled={false}
                onChange={({ target }) => {
                  setDetalle({ ...detalle, descuentoadicional: target.value });
                }}

                icono="pesos"
                className="registro_cotizaciones_descuento_adicional"
              />
              <div className="rccb-titulo">{GetText(detalle.lineaventa)}</div>
              <div className="rccb-modelo">
                <span>Modelo: </span>
                {GetText(detalle.modelo)}
              </div>
              <div className="rccb-descripcion">{detalle.descripcion}</div>
              <div className="rccbi-item">
                <span>Precio de Lista</span> <span> $ {FormatMoney(mostrarPrecioLista ? detalle.preciolista : 0)}</span>
              </div>
              <div className="rccbi-item">
                <span>Descuento Promoción</span>{" "}
                <span>
                  $ {FormatMoney(
                    !mostrarPrecioLista || detalle.preciolista === 0 || detalle.preciopromocion === 0
                      ? 0
                      : detalle.preciolista - detalle.preciopromocion
                  )}
                </span>
              </div>
              <div className="rccbi-item">
                <span>Precio Promoción</span> <span>$ {FormatMoney(detalle.preciopromocion)}</span>
              </div>
              {(detalle.lineaventa === "8 - REFACCIONES" || detalle.lineaventa === "9 - FERRETERIA") && (
                <div className="rccbi-item">
                  <span>Cantidad</span> <span>{Math.max(1, parseInt(detalle.cantidad, 10) || 1)}</span>
                </div>
              )}
              <div className="rccbi-item">
                <span>Descuento Adicional</span>{" "}
                <span>$ {FormatMoney(detalle.descuentoadicional)}</span>
              </div>
              <div className="rccbi-item">
                <span>Precio de Venta</span>{" "}
                <span>
                  $ {FormatMoney((() => {
                    const esLineCantidad =
                      detalle.lineaventa === "8 - REFACCIONES" ||
                      detalle.lineaventa === "9 - FERRETERIA";
                    const cant = esLineCantidad ? Math.max(1, parseInt(detalle.cantidad, 10) || 1) : 1;
                    const precioBaseUnitario = detalle.preciopromocion === 0 ? detalle.preciolista : detalle.preciopromocion;
                    return (precioBaseUnitario * cant) - detalle.descuentoadicional;
                  })())}
                </span>
              </div>
              <div
                className="button registro_cotizaciones_agregar_detalle"
                onClick={handleAgregarModelo}
              >
                Agregar Modelo
              </div>
            </div>
          </div>

          {/* Columna derecha: Modelos agregados */}
          <div className="registro_cotizaciones_modelos_agregados">
            <h3>Modelos agregados</h3>
            <div className="registro-cotizaciones-contenido-listado scroll">
              {modelosAgregados.length === 0 ? (
                <p>No hay modelos agregados.</p>
              ) : (
                modelosAgregados.map((m) => (
                  <div className="registro-cotizaciones-contenido-box" key={m.idTemporal}>
                    <div className="rccb-titulo">{GetText(m.lineaventa)}</div>
                    {(folio === "XXXXX" || puedeEliminar) && (
                      <div
                        className="rccb-eliminar"
                        onClick={() => handleEliminarModelo(m.idTemporal)}
                      >
                        <DeleteIcon />
                      </div>
                    )}
                    <div className="rccb-modelo">
                      <span>Modelo: </span>
                      {GetText(m.nombreModelo)}
                    </div>
                    <div className="rccb-descripcion">{m.descripcion}</div>
                    <div className="rccbi-item">
                      <span>Precio de Lista</span> <span>$ {FormatMoney(m.preciolista)}</span>
                    </div>
                    <div className="rccbi-item">
                      <span>Descuento Promoción</span>{" "}
                      <span>
                        $ {FormatMoney(
                          m.preciolista === 0 || m.preciopromocion === 0
                            ? 0
                            : m.preciolista - m.preciopromocion
                        )}
                      </span>

                    </div>
                    <div className="rccbi-item">
                      <span>Precio Promoción</span> <span>$ {FormatMoney(m.preciopromocion)}</span>
                    </div>
                    {m.cantidad > 1 && (
                      <div className="rccbi-item">
                        <span>Cantidad</span> <span>{m.cantidad}</span>
                      </div>
                    )}
                    <div className="rccbi-item">
                      <span>Descuento Adicional</span>{" "}
                      <span>$ {FormatMoney(m.descuentoadicional)}</span>
                    </div>
                    <div className="rccbi-item">
                      <span>Precio de Venta</span> <span>$ {FormatMoney(m.precioventa)}</span>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

      </div>
    </PlantillaScreen>
  );
};
